__turbopack_context__.v({
  "active": "Steps-module-scss-module__ApZuRa__active",
  "circle": "Steps-module-scss-module__ApZuRa__circle",
  "completed": "Steps-module-scss-module__ApZuRa__completed",
  "container": "Steps-module-scss-module__ApZuRa__container",
  "separator": "Steps-module-scss-module__ApZuRa__separator",
  "step": "Steps-module-scss-module__ApZuRa__step",
});
